import React from 'react'
import { useField } from '@morningtrain/react-fields'
import QuantityEditor from 'support/displays/inventory/QuantityEditor'

export default function QuantityEditorField (props) {
  const field = useField(props)

  return (
    <QuantityEditor
      {...props}
      name={field.name}
      value={field.value}
      onChange={field.onChange}
    />
  )
}
